import { PaginationOptions } from '../../shared/pagination/pagination-options';
import { QbPropertyDto } from './qb-property.dto';

export class QbPaginationDto {
  public readonly select: QbPropertyDto[];
  public readonly data: any[];
  public readonly maxSize: number;
  public readonly collectionSize: number;
  public readonly pageSize: number;
  public readonly options: PaginationOptions;
  public readonly all: (string | number)[];
  constructor(
    select: QbPropertyDto[],
    data: any[],
    maxSize: number,
    collectionSize: number,
    pageSize: number,
    options: PaginationOptions,
    all?: (string | number)[],
  ) {
    this.select = select || [];
    this.data = data || [];
    this.maxSize = maxSize;
    this.collectionSize = collectionSize;
    this.pageSize = pageSize;
    this.options = options;
    this.all = all || [];
  }

  public static fromJson(json: any): QbPaginationDto {
    if (json) {
      return new QbPaginationDto(
        json.select ? Array.from(json.select, (value: any) => QbPropertyDto.fromJson(value)) : [],
        json.data,
        json.maxSize,
        json.collectionSize,
        json.pageSize,
        PaginationOptions.fromJson(json.options),
        json.all,
      );
    }
  }
}
